<template>
    <div id="home-root" class="homeRoot">
        <mobile-home v-if="isMobile()"></mobile-home>
        <web-home v-else></web-home>
    </div>
</template>

<script>
import { isMobile } from "@/common";
import Web from "./webView/WebHome";
import Mobile from "./mobileView/MobileHome";

export default {
    name: "Home",
    components: {
        "mobile-home": Mobile,
        "web-home": Web,
    },
    data() {
        return {
            isMobile,
        };
    },
};
</script>

<style>
body,
html {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    font-family: Arial, sans-serif !important;
    height: 100% !important;
    overflow-y: hidden;
    position: relative;
}

.homeRoot {
    height: 100%;
}
</style>
